// Store name, same as folder name
export const STORE_ATTRIBUTES = 'attributes';
export const STORE_ACCOUNT = 'account';
export const STORE_AUTH_ONBOARDING = 'authOnboarding';
export const STORE_BOOST = 'boost';
export const STORE_CHAT = 'chat';
export const STORE_CONSENTS = 'consents';
export const STORE_CONTACTS = 'contacts';
export const STORE_CONTEXT = 'context';
export const STORE_DYNAMIC_UI = 'dynamicUI';
export const STORE_EMAIL = 'email';
export const STORE_ENTITIES = 'entities';
export const STORE_EXPLORE = 'explore';
export const STORE_FEEDBACK = 'feedback';
export const STORE_FILTERS = 'filters';
export const STORE_INCENTIVES = 'incentives';
export const STORE_INSENDIO = 'insendio';
export const STORE_INTERNATIONALIZATION = 'internationalization';
export const STORE_INTL_MESSAGES = 'intlMessages';
export const STORE_LIKES_YOU = 'likesYou';
export const STORE_MATCH = 'match';
export const STORE_MEDIA = 'media';
export const STORE_MM = 'mm';
export const STORE_MUTUAL_FRIENDS = 'mutualFriends';
export const STORE_MY_LIKES = 'myLikes';
export const STORE_NOTIFICATIONS = 'notifications';
export const STORE_OPTIMISTIC = 'optimistic';
export const STORE_PASSPORT = 'passport';
export const STORE_PHOTOS = 'photos';
export const STORE_PRIVACY = 'privacy';
export const STORE_PROFILE = 'profile';
export const STORE_PURCHASE = 'purchase';
export const STORE_RECS = 'recs';
export const STORE_REPORT = 'report';
export const STORE_ROUTING = 'routing';
export const STORE_SCROLL = 'scroll';
export const STORE_SEND_MESSAGES = 'sendMessages';
export const STORE_SESSION = 'session';
export const STORE_SETTINGS = 'settings';
export const STORE_SPOTIFY = 'spotify';
export const STORE_SUB_OFFER = 'subOffer';
export const STORE_STACKS_UTIL = 'stacksUtil';
export const STORE_TINDER_U = 'tinderU';
export const STORE_TINDER_SELECT = 'tinderSelect';
export const STORE_UPDATES = 'updates';
export const STORE_USER_BIOMETRICS = 'userBiometrics';
export const STORE_VAULT = 'vault';
export const STORE_WEB_PROFILE = 'webProfile';
export const STORE_WEBSOCKET = 'websocket';

export const LIFECYCLE_ACTION_TYPE_PREFIX = 'lifecycle/';
